// extracted by mini-css-extract-plugin
export default {"root":"TextFieldBase_root__IOZOU","label":"TextFieldBase_label__i22Of","errorLabel":"TextFieldBase_errorLabel__01F7N","footerLabel":"TextFieldBase_footerLabel__VWbqp"};